import { Button, Dropdown, Icon, Layout, Text } from '@loadsmart/miranda-react'

import { type Employee } from '../../domain/Employee'
import { TrackingMethod, TrackingProvider } from '../../domain/Tracking'
import { formatEmployeePhone, formatEmployeeRoles } from '../../presenters/employeesPresenter'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type DriverAssignedCardContentProps = {
  readonly driver: Employee
  readonly onClickEditDriver: () => void
  readonly onClickUnassignDriver: () => void
}

export function DriverAssignedCardContent({
  driver,
  onClickEditDriver,
  onClickUnassignDriver,
}: DriverAssignedCardContentProps) {
  return (
    <ProviderCard onClick={onClickEditDriver} filled>
      <Layout.Stack gap="spacing-4" justify="space-between" style={{ height: '100%' }}>
        <Layout.Stack gap="spacing-2">
          <Layout.Group align="center" justify="space-between">
            <ProvidersBadge
              methods={[TrackingMethod.Mobile]}
              providers={[TrackingProvider.Loadsmart, TrackingProvider.P44, TrackingProvider.TT]}
            />
            <Dropdown>
              <Button
                aria-label="Assign driver dropdown"
                variant="icon-secondary"
                size="small"
                aria-haspopup="true"
                onClick={event => {
                  event.stopPropagation()
                }}
              >
                <Icon name="dots-vertical" size="20px" color="color-primary-60" />
              </Button>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={event => {
                    event.stopPropagation()
                    onClickEditDriver()
                  }}
                >
                  Edit driver
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={event => {
                    event.stopPropagation()
                    onClickUnassignDriver()
                  }}
                >
                  <Text color="color-text-error">Unassign driver</Text>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Layout.Group>
          <Text variant="body-md-bold" color="color-primary-60">
            {driver.name}
          </Text>
          <Text variant="body-sm" color="color-text-secondary">
            {formatEmployeePhone(driver)} • {formatEmployeeRoles(driver)}
          </Text>
        </Layout.Stack>
        <Text variant="body-sm" color="color-text-placeholder">
          Location provided via Mobile app
        </Text>
      </Layout.Stack>
    </ProviderCard>
  )
}
